"use client";

import { useMemo, useState } from "react";
import { X } from "lucide-react";
import ImageComponent from "@core/helpers/client/components/image";
import SwiperComponent from "@/components/ui/swiper-component";
import Title from "@/components/Title";

const ImageGallery = ({ fields }) => {
  const gallery = fields?.gallery || [];

  const [activeIndex, setActiveIndex] = useState(0);
  const [open, setOpen] = useState(false);

  const slides = useMemo(() => gallery.map((item, index) => (
    <div
      key={`lightbox-slide-${index}`}
      className="flex items-center justify-center w-full"
    >
      <div
        className="flex items-center justify-center w-full lg:w-[500px] h-[70vh] mx-auto aspect-square lg:rounded-md lg:overflow-hidden">
        <ImageComponent
          src={item?.url || ""}
          alt={item?.alt || ""}
          width={100}
          height={100}
          className="object-contain"
          style={{ width: "100%", height: "100%", }}
        />
      </div>
    </div>
  )),
    [gallery]
  );

  const thumbs = useMemo(() => gallery.map((item, index) => (
    <div
      key={`lightbox-thumb-${index}`}
      className=" w-full lg:w-[65px] h-[65px] rounded-md overflow-hidden cursor-pointer mx-auto">
      <ImageComponent
        src={item?.url || ""}
        alt={item?.alt || ""}
        width={100}
        height={100}
        style={{ width: "100%", height: "100%", }}
        className="object-cover w-full h-full"
      />
    </div>
  )),
    [gallery]
  );

  const handleOpen = (index) => {
    setActiveIndex(index);
    setOpen(true);
  };

  const handleClose = () => { setOpen(false); };

  if (!gallery?.length) return null;

  return (
    <>
      <Title
        type={fields?.title?.type}
        className="font-bold text-jmt-main">
        {fields?.title?.title}
      </Title>

      <div
        className="columns-2 lg:columns-3 gap-2 sm:gap-3 md:gap-4 space-y-2 sm:space-y-3 md:space-y-4">
        {gallery.map((img, index) => (
          <div
            key={`masonry-image-${index}`}
            className="relative w-full overflow-hidden rounded-md cursor-pointer break-inside-avoid group"
            onClick={() => handleOpen(index)}
          >
            <div
              className="w-full h-auto rounded-md group-hover:opacity-90 transition">
              <ImageComponent
                src={img?.url || ""}
                alt={img?.alt || ""}
                width={100}
                height={100}
                className="object-cover"
                style={{ width: "100%", height: "100%", }}
              />
            </div>
          </div>
        ))}
      </div>

      {open && (
        <div
          className="fixed inset-0 bg-black z-50 flex items-center justify-center"
          onClick={handleClose}
        >

          <button
            type="button"
            onClick={handleClose}
            className="absolute top-6 left-6 text-white z-60 cursor-pointer hover:opacity-70 transition"
            aria-label="بستن">
            <X size={26} />
          </button>


          <div
            className="w-full lg:max-w-[900px] max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <SwiperComponent
              slides={slides}
              slidesPerView={1}
              navigation={true}
              navPosition="side"
              loop={false}
              grabCursor={true}
              thumbnail={true}
              thumbsSlidesPerView={5}
              thumbsSpaceBetween={6}
              thumbnail_custom_array={thumbs}
              swiper_thumbs_className="w-full mt-6"
              options={{
                initialSlide: activeIndex,
                speed: 400,
              }}
              thumb_breakpoints={{
                768: {
                  slidesPerView: 6,
                },
                1024: {
                  slidesPerView: 8,
                },
              }}
              onSlideChange={(index) => {
                setActiveIndex(index);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ImageGallery;